import { isBefore } from "date-fns";
import { IdentifiedPatientState } from "./consent.dtos";
import { OrganizationDataDeliveryType } from "./organization.dtos";
import { StudyStatus } from "./study.dtos";
export function documentDeliveryCoversStudy(delivery, studyId) {
    var _a;
    return delivery.initiatingStudyId === studyId || ((_a = delivery.additionalStudyIds) !== null && _a !== void 0 ? _a : []).includes(studyId);
}
export function organizationDeliversPatientData(dataDeliverySettings) {
    const deliveryType = dataDeliverySettings === null || dataDeliverySettings === void 0 ? void 0 : dataDeliverySettings.deliveryType;
    return !!deliveryType && deliveryType !== OrganizationDataDeliveryType.NONE;
}
export function isPatientConsentEnrolledActionNeeded(consent) {
    if (consent.pending)
        return false;
    if (consent.state !== IdentifiedPatientState.ENROLLED)
        return false;
    return !!consent.updateRecordsNeeded || !!consent.recordsRetrievalNeeded;
}
export function isPatientActivelySharingConsent(consent) {
    if (consent.pending)
        return false;
    if (consent.state !== IdentifiedPatientState.ENROLLED)
        return false;
    return !consent.updateRecordsNeeded && !consent.recordsRetrievalNeeded;
}
export function isProjectActiveForSharing(study) {
    return ![StudyStatus.COMPLETED, StudyStatus.WITHDRAWN].includes(study.status) && !study.isCompletionDateExpired;
}
export function isProjectActiveForSharingByCompletionDate(status, completionDate) {
    if ([StudyStatus.COMPLETED, StudyStatus.WITHDRAWN].includes(status))
        return false;
    if (completionDate === null || completionDate === undefined)
        return true;
    return isBefore(new Date(), new Date(completionDate));
}
